import React from "react";

import { StyledWrapper } from "./statsPanel.style";

const StatsPanel = ({ data }) => {
  const stats_data = [
    {
      label: "Companies",
      value: !isNaN(data.challengersCount)
        ? Intl.NumberFormat("en-US").format(data.challengersCount)
        : "\u00A0",
    },
    {
      label: "Users this month",
      value: !isNaN(data.usersThisMonth)
        ? Intl.NumberFormat("en-US").format(data.usersThisMonth)
        : "\u00A0",
    },
    {
      label: "Users today",
      value: !isNaN(data.usersToday)
        ? Intl.NumberFormat("en-US").format(data.usersToday)
        : "\u00A0",
    },
    {
      label: "Students",
      value: !isNaN(data.solversCount)
        ? Intl.NumberFormat("en-US").format(data.solversCount)
        : "\u00A0",
    },
    {
      label: "Users last month",
      value: !isNaN(data.usersLastMonth)
        ? Intl.NumberFormat("en-US").format(data.usersLastMonth)
        : "\u00A0",
    },
    {
      label: "Users yesterday",
      value: !isNaN(data.usersYesterday)
        ? Intl.NumberFormat("en-US").format(data.usersYesterday)
        : "\u00A0",
    },
  ];

  return (
    <StyledWrapper>
      <div className="panel-title">
        {data.totalUsers
          ? Intl.NumberFormat("en-US").format(data.totalUsers)
          : ""}{" "}
        Total users
      </div>
      <div className="panel-stats">
        {stats_data.map((item, index) => (
          <div className="panel-stat" key={index}>
            <div className="panel-stat-value">{item.value}</div>
            <div className="panel-stat-label">{item.label}</div>
          </div>
        ))}
      </div>
    </StyledWrapper>
  );
};

export default StatsPanel;
